<ds-tile class="program-tile">
  <div class="tile-heading" tile-heading>
    <div class="heading-text wrap">
      @if (!errorList) {
        <div class="flex items-center">
          <em class="heading-icon icon-money"></em>
          <span class="heading-section" dsContent [contentPath]="'billing.authAutopayTitle'"></span>
        </div>
      }
      @if (errorList) {
        <ds-error-message [errorList]="errorList"></ds-error-message>
      }
    </div>
  </div>

  <div class="tile-content" tile-content>
    <div class="pad-bottom-12">
      <p
        class="row"
        class="margin-bottom-0 margin-top-10"
        dsContent
        [contentPath]="'billing.authAutopayDetails'"
        [options]="{ billaccountNumber: confirmationDetails?.account }"
        applicationDependentCopy="true"
      ></p>
      <div class="Table condensed">
        <div class="Table-row Table-header">
          <div class="Table-row-item">Payment Amount</div>
          <div class="Table-row-item">Payment Method</div>
          <div class="Table-row-item">Due Date</div>
        </div>
        <div class="Table-row">
          <div class="Table-row-item border" data-header="Payment Amount">
            <span> {{ paymentTerm }} </span>
          </div>
          <div class="Table-row-item border" data-header="Payment Method">
            <span> {{ confirmationDetails?.paymentMethod?.nickName }} </span>
          </div>
          <div class="Table-row-item border" data-header="Due Date"><span> On due date</span></div>
        </div>
      </div>
    </div>
  </div>

  <div tile-cta class="tile-cta">
    <button ds-button class="-outline-primary margin-right-8" (click)="signup()">SIGN UP</button>
    <button
      ds-button
      class="-outline-white"
      (click)="customizeEvent.emit(confirmationDetails?.account)"
    >
      EDIT DETAILS
    </button>
  </div>
</ds-tile>

<ds-modal
  [id]="authAutopayModal"
  [closeOthers]="true"
  [maxWidth]="modalWidth"
  (onCloseModalEvent)="closeModal()"
>
  <div class="column twelve items-center">
    <ds-payment-terms-and-conditions
      authCheck
      [permissionName]="'makeautopayrule_submit_disable'"
      [checkAction]="'remove'"
      [borderColor]="''"
      [paymentMethodType]="
        confirmationDetails?.paymentMethod?.achWithdrawal ? 'autopayBank' : 'autopayCard'
      "
    ></ds-payment-terms-and-conditions>
    <div class="row flex items-center">
      <button
        ds-button
        class="-outline-primary margin-right-10 pad-horizontal-20"
        (click)="submitPayment()"
      >
        SUBMIT PAYMENT
      </button>
      <button
        ds-button
        (click)="closeModal()"
        class="-outline-white margin-right-10 pad-horizontal-20"
      >
        CANCEL
      </button>
    </div>
  </div>
</ds-modal>
